import clsx from "clsx";
import { AccountCategory } from "@/entities/DataAssociation/Account.model";
import { CATEGORY_METADATA } from "../constants/labeling.constants";
import { useEffect, useState } from "react";

export function LabelCategoryMenu({
    categories,
    onCategorySelection,
    initalCategory,
    children,
}: {
    categories: AccountCategory[];
    onCategorySelection?: (category: AccountCategory) => void;
    initalCategory?: AccountCategory;
    children?: (props: {
        selectedCategory: AccountCategory;
    }) => React.ReactNode;
}) {
    const [selectedCategory, setSelectedCategory] = useState<AccountCategory>(
        initalCategory || categories[0],
    );

    useEffect(() => {
        if (initalCategory) {
            setSelectedCategory(initalCategory);
        }
    }, [initalCategory]);

    return (
        <div
            className={clsx(
                "hide-scrollbar mt-4 flex h-full  min-h-0 flex-col overflow-auto",
            )}
        >
            <menu
                className={clsx(
                    "w-full",
                    "flex shrink-0 flex-wrap",
                    "sticky top-0 z-10 gap-x-1 gap-y-2",
                    "bg-default pb-2",
                )}
            >
                {categories.map((category) => (
                    <LabelCategoryMenuItem
                        key={category as string}
                        category={category}
                        isSelected={selectedCategory === category}
                        onClick={() => {
                            setSelectedCategory(category);
                            onCategorySelection?.(category);
                        }}
                    />
                ))}
            </menu>
            {children && (
                <div className="mt-4">{children({ selectedCategory })}</div>
            )}
        </div>
    );
}

export const LabelCategoryMenuItem = ({
    category,
    isSelected,
    onClick,
}: {
    category: AccountCategory;
    isSelected: boolean;
    onClick: (category: AccountCategory) => void;
}) => {
    const categoryMetadata = CATEGORY_METADATA[category];

    return (
        <li
            className={clsx(
                "px-2 py-1",
                "subdued flex cursor-pointer items-center gap-2 rounded capitalize",
                "hover:bg-hover",
                isSelected && "bg-selected",
            )}
            onClick={() => onClick(category)}
        >
            <div
                style={{ backgroundColor: categoryMetadata.color }}
                className="size-2 shrink-0 rounded-full"
            />
            {categoryMetadata.name}
        </li>
    );
};
